import React, { useContext } from 'react';

import { NCRContext } from 'views'

import { Modal } from 'components/form/prototypes'

const ConditionModal = ({ showModal, setShowModal, setCondition }) => {

  const { setState } = useContext(NCRContext);

  const resetOrder = () => {
    setState(prev => {
      let updated = { ...prev };
      updated.ncr.return.returnPallets = []   
      return updated;
    });
    setCondition(false);
  }
  
  const handleYes = () => {
    resetOrder()
    setShowModal(false);
  }
  const handleNo = () => {
    setShowModal(false);
  }

  const text = {
    body: (
      <>
        <b>If the order is not in the same condition as it was sent out, then you will need to fill in the Pallet details for this return.</b><br /><br />
        <b>If it is in the same condition, then Pallet details will be populated from the Despatch Note.</b><br />
        <br />Are you sure you want to proceed?
      </>
    ),
    yes: <>Yes, I'm sure</>,
    no: <>No, the order is the same</>
  }

  return (
    <Modal showModal={showModal} setShowModal={setShowModal} handleYes={handleYes} handleNo={handleNo} text={text} />
  )
}

export { ConditionModal };
